module.exports = __webpack_public_path__ + "static/img/2.e7f1afa.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/xiaoshuo/2.png
// module id = n6PT
// module chunks = 1